import { render, staticRenderFns } from "./ListInsuranceCompany.vue?vue&type=template&id=59565b88"
import script from "./ListInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./ListInsuranceCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports